import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import api from "../../../utils/Url";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { getISTDate, getId } from "../../../utils/Constant";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import CustomLabel from "../../../CustomLable";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import DataGrids from "../../../utils/Datagrids";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function Jurisdiction() {
  const { i18n, t } = useTranslation();
  const { defaultValues, defaultValuestime } = getISTDate();
  const userId = getId();
  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [editId, setEditId] = useState<any>(-1);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  // const [lang, setLang] = useState<Language>("en");
  const [NodeOption, setNodeOption] = useState([
    { value: "-1", label: t("text.SelectNode") },
  ]);

  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  const getNode = () => {

    api.get(`NewNodeMaster/GetAllNodes`).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.nodeName,
        value: item.nodeId,
      }));
      setNodeOption(arr);
    });
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    getNode();
  }, []);

  let delete_id = "";
  const accept = () => {
    const collectData = {
      nodeId: delete_id,
    };
    // console.log("collectData " + JSON.stringify(collectData));
    api.post(`NewNodeMaster/DeleteNode`, collectData).then((response) => {
      if (response.data.status) {
        toast.success(response.data.message);
        getList();
      } else {
        toast.error(response.data.message);
      }
    });
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const getList = () => {

    try {
      api.get(`NewNodeMaster/GetAllNodes`).then((res) => {
        // console.log("result" + JSON.stringify(res.data.data));
        const data = res.data.data;
        const arr = data.map((item: any, index: any) => ({
          ...item,
          serialNo: index + 1,
          id: item.nodeId,
        }));
        setRows(arr);
        setIsLoading(false);
        if (data.length > 0) {
          const columns: GridColDef[] = [
            {
              field: "actions",
              headerClassName: "MuiDataGrid-colCell",
              headerName: t("text.Action"),
              width: 150,

              renderCell: (params) => {
                return [
                  <Stack
                    spacing={1}
                    direction="row"
                    sx={{ alignItems: "center", marginTop: "5px" }}
                  >
                    {/* {permissionData?.isEdit ? ( */}
                    <EditIcon
                      style={{
                        fontSize: "20px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      className="cursor-pointer"
                      onClick={() => routeChangeEdit(params.row)}
                    />
                    {/* ) : (
                      ""
                    )} */}
                    {/* {permissionData?.isDel ? ( */}
                    <DeleteIcon
                      style={{
                        fontSize: "20px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handledeleteClick(params.row.id);
                      }}
                    />
                    {/* ) : (
                      ""
                    )} */}
                  </Stack>,
                ];
              },
            },

            {
              field: "serialNo",
              headerName: t("text.SrNo"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
            },
            {
              field: "nodeName",
              headerName: t("text.Juridiction"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
            },
            {
              field: "location",
              headerName: t("text.location"),
              flex: 1,
              headerClassName: "MuiDataGrid-colCell",
            },
          ];
          setColumns(columns as any);
        }
      });

    } catch (error) {
      console.error("Error fetching data:", error);

    }
  };

  const validationSchema = Yup.object({
    nodeId: Yup.string().test(
      "required",
      "Node Required",
      function (value: any) {
        return value && value.trim() !== "";
      }),
    location: Yup.string().test(
      "required",
      "Location Required",
      function (value: any) {
        return value && value.trim() !== "";
      })
  });

  const [toaster, setToaster] = useState(false);

  const formik = useFormik({
    initialValues: {
      activeClass: "",
      all: true,
      showExisting: true,
      isSuccess: true,
      message: "",
      srno: 0,
      eScarp: true,
      eScarpPrevValue: "",
      css: "",
      nodeId: null,
      nodeName: "",
      parentId: 0,
      displayNo: 0,
      location: "",
      srn: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {


      const response = await api.post(`NewNodeMaster/AddUpdateNode`, values);
      if (response.data.status) {
        setToaster(false);
        toast.success(response.data.message);
        formik.resetForm();
        getList();
        setEditId(-1);
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const requiredFields = ["nodeId"];

  const routeChangeEdit = (row: any) => {
    formik.setFieldValue("nodeId", row.nodeId);
    formik.setFieldValue("nodeName", row.nodeName);
    formik.setFieldValue("location", row.location);

    formik.setFieldValue("parentId", row.parentId);

    setEditId(row.id);
  };

  const handleSubmitWrapper = async () => {
    await formik.handleSubmit();
  };

  const handleConversionChange = (params: any, text: string) => {
    formik.setFieldValue(params, text);
  };

  return (
    <>
      <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
        <Card
          style={{
            width: "100%",
            height: "50%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid #2B4593 ",
            marginTop: "5px",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",

            }}
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={10} md={10} xs={12}>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  sx={{ padding: "20px" }}
                  align="left"
                >
                  {t("text.JurisdictionMaster")}
                </Typography>
              </Grid>

              <Grid item lg={2} md={2} xs={12} marginTop={2}>
                <select
                  className="language-dropdown"
                // value={lang}
                // onChange={(e) => setLang(e.target.value as Language)}
                >
                  {Languages.map((l) => (
                    <option key={l.value} value={l.value}>
                      {l.label}
                    </option>
                  ))}
                </select>
              </Grid>
            </Grid>

            <Divider />

            <Box height={10} />

            <form onSubmit={formik.handleSubmit}>
              <Grid item xs={12} container spacing={3}>
                <Grid xs={5} sm={5} item>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={NodeOption}
                    value={
                      NodeOption.find(
                        (option: any) => option.value === formik.values.nodeId
                      ) || null
                    }
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      console.log(newValue?.value);

                      formik.setFieldValue("nodeId", newValue?.value);
                      formik.setFieldValue("nodeName", newValue?.label);

                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <CustomLabel
                            text={t("text.SelectNode")}
                            required={requiredFields.includes("nodeId")}
                          />
                        }
                      />
                    )}
                  />

                  {formik.touched.nodeId && formik.errors.nodeId ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.nodeId}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={5}>
                  <TextField
                    id="location"
                    name="location"
                    label={<CustomLabel text={t("text.Elocation")} />}
                    value={formik.values.location}
                    placeholder={t("text.Elocation")}
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.location && formik.errors.location ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.location}
                    </div>
                  ) : null}
                </Grid>



                <Grid item xs={2} sx={{ m: -1 }}>
                  {editId === -1 ? (
                    <ButtonWithLoader
                      buttonText={t("text.save")}
                      onClickHandler={handleSubmitWrapper}
                      fullWidth={true}
                    />
                  ) : (
                    <ButtonWithLoader
                      buttonText={t("text.update")}
                      onClickHandler={handleSubmitWrapper}
                      fullWidth={true}
                    />
                  )}
                </Grid>
              </Grid>
            </form>
            {/* </Grid> */}
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            ></Typography>
            {/* </Stack> */}
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <DataGrids
                isLoading={isLoading}
                rows={rows}
                columns={columns}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                initialPageSize={5}
              />
            )}
          </Paper>
        </Card>
      </Grid>
      <ToastApp />
    </>
  );
}
